import {
  queryRole,
  addRole,
  updateRole,
  removeRole,
  recoverRole,
} from 'liyu-pc-base/api/permission/role-manage';
import type { TableColumn } from 'liyu-pc-base/typing';
import type { SearchConfig, Record } from 'liyu-pc-base/components/remotePages/typing';
import { useUserStore } from 'liyu-pc-base/init-plugin';
import { btn_list, head_btn_list, config } from './permission-role-manage-config';
import { event_obj } from 'liyu-pc-base/init-plugin';
import { reactive } from 'vue';

export default () => {
  const userStore = useUserStore();
  const current_org = userStore.currentOrg; // 当前组织org
  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'remoteselect',
        name: 'aim_org_id',
        label: '目标组织',
        disabled: false,
        placeholder: '请选择目标组织',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        labelKey: 'name',
        valueKey: 'id',
        modalType: 'sys-query_org_for_login_list',
      },
      {
        type: 'input',
        name: 'name',
        label: '角色名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写角色名称',
      },
      {
        type: 'radio',
        name: 'is_active',
        label: '状态',
        mode: 'default',
        disabled: false,
        defaultValue: '',
        labelKey: 'name',
        valueKey: 'value',
        placeholder: '请选择状态',
        datasource: 'is_active',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org.id,
      aim_org_id: current_org.id,
      is_active: true,
      name: '',
    }),
  };
  const search_options = {
    is_active: [
      { name: '全部', value: '' },
      { name: '正常', value: true },
      { name: '作废', value: false },
    ],
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'vertical',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '角色名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写角色名称',
      },
      {
        type: 'input',
        name: 'flag',
        label: '角色标识',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写角色标识',
      },
      {
        type: 'textarea',
        name: 'desc',
        label: '角色描述',
        disabled: false,
        allowClear: true,
        defaultValue: '',
        placeholder: '请填写角色描述',
      },
    ],
    rules: {
      name: [{ required: true, message: '角色名称必须填写' }],
    },
    model: {
      org_id: current_org.id,
      aim_org_id: current_org.id,
      id: null,
      name: '',
      desc: '',
    },
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'vertical',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '角色名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写角色名称',
      },
      {
        type: 'input',
        name: 'flag',
        label: '角色标识',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写角色标识',
      },
      {
        type: 'textarea',
        name: 'desc',
        label: '角色描述',
        disabled: false,
        allowClear: true,
        defaultValue: '',
        placeholder: '请填写角色描述',
      },
    ],
    rules: {},
    model: {
      org_id: current_org.id,
      aim_org_id: current_org.id,
      id: null,
      name: '',
      desc: '',
    },
  };
  const update_model_config_options = {};

  const titleList = {
    title: '角色管理',
    addModalTitle: '新建角色',
    updateTitle: '修改',
    is_create: true, // 是否有【新建】按钮
    is_update: true, // 是否有【修改】按钮
    is_remove: true, // 是否有【删除】按钮
    is_recover: true, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      role_id: 'id',
    },
    delete: {
      role_id: 'id',
    },
    recover: {
      role_id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      role_id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      width: 50,
      dataIndex: 'index',
      checked: true,
      fixed: 'left',
    },
    {
      title: '名称',
      width: 150,
      dataIndex: 'name',
      checked: true,
      fixed: 'left',
    },
    {
      title: '描述',
      dataIndex: 'desc',
      checked: true,
    },
    {
      title: '角色标识',
      width: 180,
      dataIndex: 'flag',
      checked: true,
    },
    {
      title: '是否可用',
      width: 100,
      dataIndex: 'is_active',
      checked: true,
      resizable: true,
      cellComponent: 'boolean',
      name1: '可用',
      name2: '禁用',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '可用', value: 'true' },
        { text: '禁用', value: 'false' },
      ],
    },
    {
      title: '操作',
      width: 50,
      dataIndex: 'action',
      checked: true,
      cellComponent: 'action',
    },
  ];

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: queryRole,
    addData: addRole,
    updateData: updateRole,
    removeData: removeRole,
    recoverData: recoverRole,
    baseColumns: baseColumns,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj(),
    base_search_condition_config_list: [],
    default_search_condition_config_list: [[]],
    condition_group_config_list: [],
    is_show_advantage: false,
    is_show_normal_search: true,
    is_only_show_advantage: false,
    is_only_show_normal_search: true,
    queryConditionGroupData: null,
    isView: false,
  };
};
